import React from 'react';
import classNames from 'classnames';

import { useTabsContext } from '../tabsContext';

import styles from './tabStyles.scss';

const TabNav: React.FC<{ children: JSX.Element[]; className?: string }> = ({
  children,
  className
}): React.ReactElement => {
  const { activeTab, selectTab } = useTabsContext();

  return (
    <div className={classNames(styles.tabs, className)}>
      {children &&
        children.map(
          (child, idx): React.ReactElement => (
            <a
              key={idx}
              className={classNames(styles.tabLink, {
                [styles.selected]: idx === activeTab
              })}
              onClick={(): void => selectTab(idx)}
            >
              {child}
            </a>
          )
        )}
    </div>
  );
};

export default TabNav;
